// Shared display helpers for AIRTIME categories, priorities and formatting.

export const CATEGORY_META = {
  ACTION_REQUIRED: { label: "ACTION REQUISE", cls: "text-rose-300 bg-rose-500/10 border-rose-500/30", dot: "bg-rose-400" },
  REPLY: { label: "À RÉPONDRE", cls: "text-sky-300 bg-sky-500/10 border-sky-500/30", dot: "bg-sky-400" },
  WAITING_FOR: { label: "EN ATTENTE", cls: "text-amber-300 bg-amber-500/10 border-amber-500/30", dot: "bg-amber-400" },
  DEADLINE: { label: "ÉCHÉANCE", cls: "text-rose-200 bg-rose-600/10 border-rose-600/30", dot: "bg-rose-500" },
  MEETING: { label: "RÉUNION", cls: "text-violet-300 bg-violet-500/10 border-violet-500/30", dot: "bg-violet-400" },
  FYI: { label: "POUR INFO", cls: "text-zinc-300 bg-zinc-500/10 border-zinc-500/30", dot: "bg-zinc-400" },
  LOW_PRIORITY: { label: "PRIORITÉ BASSE", cls: "text-zinc-400 bg-zinc-500/5 border-zinc-500/20", dot: "bg-zinc-500" },
};

export const CATEGORY_ORDER = ["ACTION_REQUIRED", "REPLY", "WAITING_FOR", "DEADLINE", "MEETING", "FYI", "LOW_PRIORITY"];

export const PRIORITY_META = {
  URGENT: { label: "URGENT", cls: "text-rose-400 bg-rose-500/10 border-rose-500/30" },
  IMPORTANT: { label: "IMPORTANT", cls: "text-amber-400 bg-amber-500/10 border-amber-500/30" },
  QUICK_WIN: { label: "QUICK WIN", cls: "text-emerald-400 bg-emerald-500/10 border-emerald-500/30" },
  THIS_WEEK: { label: "CETTE SEMAINE", cls: "text-sky-400 bg-sky-500/10 border-sky-500/30" },
  CAN_WAIT: { label: "PEUT ATTENDRE", cls: "text-zinc-400 bg-zinc-500/10 border-zinc-500/20" },
};

export const STATUS_META = {
  inbox: { label: "Inbox" },
  today: { label: "Aujourd'hui" },
  this_week: { label: "Cette semaine" },
  planned: { label: "Planifiée" },
  later: { label: "Plus tard" },
  waiting: { label: "En attente" },
  done: { label: "Terminé" },
};

export const BLOCK_META = {
  FIXED: "bg-sky-500/10 border-l-4 border-l-sky-500 border border-sky-500/20 text-sky-200",
  FLEXIBLE: "bg-indigo-500/10 border border-dashed border-indigo-500/40 text-indigo-200",
  TASK: "bg-indigo-500/20 border-l-4 border-l-indigo-400 border border-indigo-500/30 text-indigo-100",
  PERSONAL: "bg-emerald-500/15 border-l-4 border-l-emerald-500 border border-emerald-500/30 text-emerald-200",
  BUFFER: "bg-zinc-700/20 border border-zinc-600/20 text-zinc-400",
};

export function fmtDur(min) {
  if (!min) return "—";
  const h = Math.floor(min / 60), m = min % 60;
  if (h && m) return `${h}h${String(m).padStart(2, "0")}`;
  if (h) return `${h}h`;
  return `${m}min`;
}

export function fmtDeadline(iso) {
  if (!iso) return null;
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("fr-FR", { day: "numeric", month: "short" });
  } catch { return iso; }
}
